<!-- Header de página -->
<div class="page-header">
    <div class="d-flex justify-content-between align-items-center">
        <div>
            <h1 class="page-title">LIQUIDACIONES AGENCIA</h1>
            <p class="page-subtitle text-muted">
                Gestión y consulta de liquidaciones de agencia
            </p>
        </div>
        <div class="header-actions">
            <!-- Indicador de selección -->
            <div class="selection-indicator" *ngIf="getSelectedCount() > 0">
                <span class="selection-count">
                    <mat-icon>check_box</mat-icon>
                    {{ getSelectedCount() }} seleccionado{{
                        getSelectedCount() > 1 ? 's' : ''
                    }}
                </span>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="generarExcelFusionado()"
                    [disabled]="
                        isGeneratingExcelFusionado || getSelectedCount() === 0
                    "
                    matTooltip="Descargar un único Excel con todas las liquidaciones seleccionadas"
                >
                    <mat-icon>archive</mat-icon>
                    Consolidado
                </button>
                <button
                    mat-stroked-button
                    color="warn"
                    (click)="clearAllSelections()"
                    matTooltip="Limpiar selección"
                >
                    <mat-icon>clear</mat-icon>
                    Limpiar
                </button>
            </div>
            <button
                mat-raised-button
                color="primary"
                *ngIf="isFacturacionVisible"
                (click)="exportarExcelFacturacion()"
                [disabled]="isGeneratingFacturacion"
                matTooltip="Exportar el desglose de facturación de las liquidaciones seleccionadas, o de todas las filtradas si no hay selección"
            >
                <mat-icon>request_quote</mat-icon>
                {{
                    isGeneratingFacturacion
                        ? 'Generando...'
                        : 'Excel Facturación'
                }}
            </button>
            <button
                mat-raised-button
                color="accent"
                (click)="exportarExcel()"
                [disabled]="isLoading || isGeneratingExcel"
                matTooltip="Exportar datos actuales a Excel"
            >
                <mat-icon>download</mat-icon>
                Excel
            </button>
        </div>
    </div>
</div>

<!-- Filtros de búsqueda -->
<mat-card class="filters-card">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>filter_list</mat-icon>
            Filtros de Búsqueda
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
        <div class="filters-section">
            <div class="filters-grid filters-grid-50">
                <!-- Campo para usuarios con rol cliente (input deshabilitado) -->
                <mat-form-field
                    *ngIf="isClienteRole"
                    appearance="outline"
                    class="filter-field"
                >
                    <mat-label>Cliente</mat-label>
                    <input
                        matInput
                        [formControl]="clienteControl"
                        placeholder="Cliente asignado"
                        readonly
                        inputmode="text"
                    />
                    <mat-icon matSuffix color="primary">person</mat-icon>
                </mat-form-field>

                <!-- Campo para otros roles (autocomplete habilitado) -->
                <mat-form-field
                    *ngIf="!isClienteRole"
                    appearance="outline"
                    class="filter-field"
                >
                    <mat-label>Cliente</mat-label>
                    <input
                        matInput
                        [formControl]="clienteControl"
                        [matAutocomplete]="autoCliente"
                        placeholder="Buscar cliente..."
                        inputmode="text"
                    />
                    <mat-autocomplete
                        #autoCliente="matAutocomplete"
                        [displayWith]="mostrarCliente"
                        (optionSelected)="
                            onClienteSeleccionado($event.option.value)
                        "
                    >
                        <mat-option
                            *ngIf="isLoadingClientes"
                            class="loading-option"
                            disabled
                        >
                            <i class="ri-loader-4-line animate-spin me-2"></i>
                            Cargando clientes...
                        </mat-option>
                        <mat-option
                            *ngFor="let cliente of clientesFiltrados | async"
                            [value]="cliente"
                        >
                            {{ cliente.cliente }}
                        </mat-option>
                        <mat-option
                            *ngIf="
                                !isLoadingClientes &&
                                (clientesFiltrados | async)?.length === 0
                            "
                            disabled
                        >
                            No se encontraron clientes
                        </mat-option>
                    </mat-autocomplete>
                    <button
                        *ngIf="clienteSeleccionado"
                        mat-icon-button
                        matSuffix
                        (click)="limpiarCliente()"
                        type="button"
                        matTooltip="Limpiar cliente"
                    >
                        <mat-icon>clear</mat-icon>
                    </button>
                    <mat-icon *ngIf="!clienteSeleccionado" matSuffix
                        >search</mat-icon
                    >
                </mat-form-field>

                <!-- Punto A.1 (OPB, ago-2026): Tipo, N° Factura, N° Nota de Cobro y
                     N° Liquidación. Se resuelven en el backend, por eso buscan con
                     Enter o con el botón Buscar (no filtran la página ya cargada). -->
                <!-- Punto A.2: el módulo abre mostrando sólo las Finalizadas. Es un
                     valor por defecto, no un filtro fijo: se puede cambiar o ver todos. -->
                <!-- Punto A.2 (OPB, ago-2026): el CLIENTE no elige el estado — el
                     backend le fuerza "Finalizado". El admin sí lo ve, porque necesita
                     consultar Activas y Liquidadas para dar soporte. -->
                <mat-form-field
                    appearance="outline"
                    class="filter-field"
                    *ngIf="!isClienteRole"
                >
                    <mat-label>Estado</mat-label>
                    <mat-select
                        [(ngModel)]="filtroEstado"
                        [ngModelOptions]="{ standalone: true }"
                    >
                        <mat-option [value]="null">Todos</mat-option>
                        <mat-option
                            *ngFor="let estado of opcionesEstado"
                            [value]="estado.id"
                        >
                            {{ estado.nombre }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>flag</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Tipo</mat-label>
                    <mat-select
                        [(ngModel)]="filtroTipo"
                        [ngModelOptions]="{ standalone: true }"
                    >
                        <mat-option [value]="null">Todos</mat-option>
                        <mat-option
                            *ngFor="let tipo of opcionesTipo"
                            [value]="tipo.id"
                        >
                            {{ tipo.nombre }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>category</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Nro. Factura</mat-label>
                    <input
                        matInput
                        [(ngModel)]="filtroNroFactura"
                        [ngModelOptions]="{ standalone: true }"
                        (keyup.enter)="aplicarFiltrosBackend()"
                        placeholder="Ej: 1169"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Nro. Nota de Cobro</mat-label>
                    <input
                        matInput
                        [(ngModel)]="filtroNroNotaCobro"
                        [ngModelOptions]="{ standalone: true }"
                        (keyup.enter)="aplicarFiltrosBackend()"
                        placeholder="Ingresa el número"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Nro. Liquidación</mat-label>
                    <input
                        matInput
                        [(ngModel)]="filtroNroLiquidacion"
                        [ngModelOptions]="{ standalone: true }"
                        (keyup.enter)="aplicarFiltrosBackend()"
                        placeholder="Ej: 1613"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Temporada</mat-label>
                    <mat-select
                        [(ngModel)]="filtroTemporada"
                        [ngModelOptions]="{ standalone: true }"
                    >
                        <mat-option [value]="null"
                            >Todas las temporadas</mat-option
                        >
                        <mat-option
                            *ngFor="let temporada of temporadasDisplayOptions"
                            [value]="temporada.value"
                        >
                            {{ temporada.label }}
                        </mat-option>
                    </mat-select>
                    <mat-icon matSuffix>calendar_today</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Fecha de Inicio</mat-label>
                    <input
                        matInput
                        [matDatepicker]="pickerInicio"
                        [(ngModel)]="filtroFechaInicio"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Seleccionar fecha de inicio"
                        inputmode="none"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="pickerInicio"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerInicio></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field">
                    <mat-label>Fecha de Fin</mat-label>
                    <input
                        matInput
                        [matDatepicker]="pickerFin"
                        [(ngModel)]="filtroFechaFin"
                        [ngModelOptions]="{ standalone: true }"
                        placeholder="Seleccionar fecha de fin"
                        inputmode="none"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="pickerFin"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #pickerFin></mat-datepicker>
                </mat-form-field>
            </div>

            <!-- Botones de acción -->
            <div class="filter-actions">
                <button
                    mat-raised-button
                    color="primary"
                    (click)="aplicarFiltrosBackend()"
                    [disabled]="isLoading"
                    matTooltip="Buscar con los filtros aplicados"
                >
                    <mat-icon>search</mat-icon>
                    Buscar
                </button>
                <button
                    mat-raised-button
                    color="warn"
                    (click)="limpiarFiltros()"
                    [disabled]="isLoading"
                    matTooltip="Limpiar todos los filtros"
                >
                    <mat-icon>clear</mat-icon>
                    Limpiar
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<!-- Tabla de datos -->
<mat-card class="data-card">
    <mat-card-content>
        <!-- Estado de carga -->
        <div class="loading-container" *ngIf="isLoading">
            <div class="loading-spinner">
                <i class="ri-loader-4-line"></i>
                <p>{{ loadingMessage }}</p>
            </div>
        </div>

        <div class="liquidaciones-list-table" *ngIf="!isLoading">
            <div class="table-responsive">
                <table
                    mat-table
                    [dataSource]="filteredDataSource"
                    matSort
                    (matSortChange)="onSortChange($event)"
                >
                    <!-- Checkbox Column -->
                    <ng-container matColumnDef="select">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            class="checkbox-column"
                        >
                            <mat-checkbox
                                [checked]="isAllPageSelected()"
                                [indeterminate]="isSomePageSelected()"
                                (change)="toggleAllPage()"
                                color="primary"
                                matTooltip="Seleccionar/deseleccionar todos de esta página"
                            >
                            </mat-checkbox>
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="checkbox-column"
                        >
                            <mat-checkbox
                                [checked]="isSelected(element)"
                                (change)="toggleSelection(element)"
                                (click)="$event.stopPropagation()"
                                (keydown.space)="$event.stopPropagation()"
                                color="primary"
                            >
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Número de Liquidación Column -->
                    <ng-container matColumnDef="numeroLiquidacion">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="pl-0"
                        >
                            N° Liq.
                        </th>
                        <td mat-cell *matCellDef="let element" class="pl-0">
                            {{ element.numeroLiquidacion }}
                        </td>
                    </ng-container>

                    <!-- Mes/Año Column -->
                    <ng-container matColumnDef="mesAnio">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Mes/Año
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ formatearMesAnio(element.mesAnio) }}
                        </td>
                    </ng-container>

                    <!-- Cliente Column -->
                    <ng-container matColumnDef="cliente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Cliente
                        </th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.cliente }}
                        </td>
                    </ng-container>

                    <!-- Nave Column -->
                    <ng-container matColumnDef="nave">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Nave
                        </th>
                        <td mat-cell *matCellDef="let element">
                            @if (element.nave?.startsWith('Múltiples')) {
                            <span
                                class="nave-multiple"
                                [matTooltip]="element.navesTooltip"
                                matTooltipPosition="above"
                            >
                                {{ element.nave }}
                            </span>
                            } @else {
                            <span>{{ element.nave }}</span>
                            }
                        </td>
                    </ng-container>

                    <!-- Estado Column -->
                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Estado
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span
                                class="trinta-badge fw-medium d-inline-block"
                                *ngIf="element.estado === 'PENDIENTE'"
                            >
                                Pendiente
                            </span>
                            <span
                                class="trinta-badge fw-medium onHand d-inline-block"
                                *ngIf="element.estado === 'APROBADA'"
                            >
                                Aprobada
                            </span>
                            <span
                                class="trinta-badge fw-medium urgent d-inline-block"
                                *ngIf="element.estado === 'RECHAZADA'"
                            >
                                Rechazada
                            </span>
                            <span
                                class="trinta-badge fw-medium primary d-inline-block"
                                *ngIf="element.estado === 'PAGADA'"
                            >
                                Pagada
                            </span>
                            <!-- Estado default para valores que no coinciden exactamente -->
                            <span
                                class="trinta-badge fw-medium d-inline-block"
                                *ngIf="
                                    element.estado &&
                                    element.estado !== 'PENDIENTE' &&
                                    element.estado !== 'APROBADA' &&
                                    element.estado !== 'RECHAZADA' &&
                                    element.estado !== 'PAGADA'
                                "
                            >
                                {{ element.estado }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- Tipo Column (estilo igual a Estado) -->
                    <ng-container matColumnDef="tipo">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Tipo
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <span class="trinta-badge fw-medium d-inline-block">
                                {{ element.tipo }}
                            </span>
                        </td>
                    </ng-container>

                    <!-- CNTR Column -->
                    <ng-container matColumnDef="cntr">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            CNTR
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="cantidad-cntr">{{
                                formatearNumero(element.cntr)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- PLTS Column -->
                    <ng-container matColumnDef="plts">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            PLTS
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="cantidad-plts">{{
                                formatearNumero(element.plts)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- Agenciamiento Column -->
                    <ng-container matColumnDef="agenciamiento">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            Agenciamiento
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-agenciamiento">{{
                                formatearMoneda(element.agenciamiento)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- Transporte Column -->
                    <ng-container matColumnDef="transporte">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            Transporte
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-transporte">{{
                                formatearMoneda(element.transporte)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- OS Venta Column -->
                    <ng-container matColumnDef="osVenta">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            OS Venta
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-os-venta">{{
                                formatearMoneda(element.osVenta)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- Total Venta Neto Column -->
                    <ng-container matColumnDef="totalVentaNeto">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            Total Venta Neto
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-total-venta-neto">{{
                                formatearMoneda(element.totalVentaNeto)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- Total Traspaso Bruto Column -->
                    <ng-container matColumnDef="osTraspaso">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            Total Traspaso Bruto
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-os-traspaso">{{
                                formatearMoneda(element.osTraspaso)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- Total Column -->
                    <ng-container matColumnDef="total">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            mat-sort-header
                            class="text-end"
                        >
                            Total
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-end">
                            <span class="monto-total">{{
                                formatearMoneda(element.total)
                            }}</span>
                        </td>
                    </ng-container>

                    <!-- Action Column -->
                    <ng-container matColumnDef="acciones">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            class="text-end pr-0"
                        ></th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="text-end pr-0"
                        >
                            <div class="action">
                                <button
                                    type="button"
                                    mat-button
                                    class="p-0 min-w-auto lh-1 h-auto"
                                    (click)="verDetalle(element)"
                                    matTooltip="Ver Detalle"
                                >
                                    <i class="ri-eye-line"></i>
                                </button>
                                <button
                                    type="button"
                                    mat-button
                                    class="p-0 min-w-auto lh-1 h-auto"
                                    (click)="generarExcel(element)"
                                    matTooltip="Generar Excel"
                                >
                                    <i class="ri-file-excel-2-line"></i>
                                </button>
                                <button
                                    type="button"
                                    mat-button
                                    class="p-0 min-w-auto lh-1 h-auto"
                                    (click)="generarPdfAgencia(element)"
                                    matTooltip="Generar PDF"
                                >
                                    <i class="ri-file-pdf-line"></i>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Fila de totales usando mat-footer-row -->
                    <ng-container matColumnDef="totales-select">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="checkbox-column totales-cell-sin-estilo"
                        ></td>
                    </ng-container>

                    <ng-container matColumnDef="totales-numeroLiquidacion">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="pl-0 totales-cell-sin-estilo"
                        ></td>
                    </ng-container>

                    <ng-container matColumnDef="totales-mesAnio">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell-sin-estilo"
                        ></td>
                    </ng-container>

                    <ng-container matColumnDef="totales-cliente">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell-sin-estilo"
                        ></td>
                    </ng-container>

                    <ng-container matColumnDef="totales-nave">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell-sin-estilo"
                        ></td>
                    </ng-container>

                    <ng-container matColumnDef="totales-estado">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell-sin-estilo"
                        ></td>
                    </ng-container>

                    <ng-container matColumnDef="totales-tipo">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-center"
                        >
                            <strong>TOTALES</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-cntr">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="cantidad-cntr">{{
                                formatearNumero(totales.cntr)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-plts">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="cantidad-plts">{{
                                formatearNumero(totales.plts)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-agenciamiento">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="monto-agenciamiento">{{
                                formatearMoneda(totales.agenciamiento)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-transporte">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="monto-transporte">{{
                                formatearMoneda(totales.transporte)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-osVenta">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="monto-os-venta">{{
                                formatearMoneda(totales.osVenta)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-totalVentaNeto">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="monto-total-venta-neto">{{
                                formatearMoneda(totales.totalVentaNeto)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-osTraspaso">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="monto-os-traspaso">{{
                                formatearMoneda(totales.osTraspaso)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-total">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="totales-cell text-end"
                        >
                            <strong class="monto-total">{{
                                formatearMoneda(totales.total)
                            }}</strong>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totales-acciones">
                        <td
                            mat-footer-cell
                            *matFooterCellDef
                            class="text-end pr-0 totales-cell-sin-estilo"
                        ></td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>

                    <ng-container
                        *ngIf="filteredDataSource.length > 0 && !isLoading"
                    >
                        <tr
                            mat-footer-row
                            *matFooterRowDef="displayedColumnsWithTotales"
                            class="totales-footer-row"
                        ></tr>
                    </ng-container>
                </table>
            </div>

            <!-- Mensaje cuando no hay datos -->
            <div
                class="no-data"
                *ngIf="filteredDataSource.length === 0 && !isLoading"
            >
                <i class="ri-inbox-line"></i>
                <p>
                    No se encontraron liquidaciones de agencia que coincidan con
                    los filtros aplicados.
                </p>
            </div>

            <mat-paginator
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageSizeOptions]="pageSizeOptions"
                [pageIndex]="currentPage - 1"
                (page)="onPageChange($event)"
                showFirstLastButtons
            >
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>

<!-- Overlay de carga para generación de Excel -->
<div
    *ngIf="isGeneratingExcel || isGeneratingExcelFusionado"
    class="excel-loading-overlay"
>
    <div class="excel-loading-content">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="excel-loading-text">
            {{
                isGeneratingExcelFusionado
                    ? 'Generando Excel fusionado...'
                    : 'Generando Archivo Excel...'
            }}
        </p>
    </div>
</div>
